import React from 'react';



export const AppTopbar = () => {


    return (
        <div className="layout-topbar">
            <div className="layout-topbar-wrapper">
                <h1><i>Acinetobacter baumannii</i> K locus sequence submission portal</h1>
            </div>
        </div>
    );


}

export default AppTopbar;